/**
 * Rótulos e selos do módulo de manutenção.
 *
 * Um arquivo só para os três enums do domínio não aparecerem traduzidos de
 * jeitos diferentes em três telas — o operador precisa ver a mesma palavra.
 */
import type {
  MaintenanceChecklistKindDto,
  MaintenanceCriticalityDto,
  MaintenanceNonConformityStatusDto,
  MaintenanceRunStatusDto,
  MaintenanceWorkOrderStatusDto,
} from "@bi/types";

export const KIND_LABEL: Record<MaintenanceChecklistKindDto, string> = {
  delivery: "Entrega",
  return_delivery: "Devolução",
  inspection: "Inspeção",
  maintenance: "Manutenção",
  daily: "Diário",
  work_order: "Execução da O.S.",
};

export const RUN_STATUS: Record<MaintenanceRunStatusDto, { label: string; badge: string }> = {
  draft: { label: "Rascunho", badge: "badge-gray" },
  in_progress: { label: "Em andamento", badge: "badge-amber" },
  completed: { label: "Concluído", badge: "badge-green" },
  cancelled: { label: "Cancelado", badge: "badge-gray" },
};

export const NC_STATUS: Record<MaintenanceNonConformityStatusDto, { label: string; badge: string }> = {
  open: { label: "Aberta", badge: "badge-red" },
  in_analysis: { label: "Em análise", badge: "badge-amber" },
  resolved: { label: "Resolvida", badge: "badge-green" },
  cancelled: { label: "Cancelada", badge: "badge-gray" },
};

export const WO_STATUS: Record<MaintenanceWorkOrderStatusDto, { label: string; badge: string }> = {
  open: { label: "Aberta", badge: "badge-red" },
  scheduled: { label: "Agendada", badge: "badge-amber" },
  in_progress: { label: "Em execução", badge: "badge-amber" },
  waiting_parts: { label: "Aguardando peças", badge: "badge-amber" },
  completed: { label: "Concluída", badge: "badge-green" },
  cancelled: { label: "Cancelada", badge: "badge-gray" },
};

export const CRITICALITY: Record<MaintenanceCriticalityDto, { label: string; badge: string }> = {
  low: { label: "Baixa", badge: "badge-gray" },
  medium: { label: "Média", badge: "badge-amber" },
  high: { label: "Alta", badge: "badge-red" },
};

export function CriticalityBadge({ value }: { value: MaintenanceCriticalityDto }) {
  const c = CRITICALITY[value];
  return <span className={c.badge}>{c.label}</span>;
}

/** Opções de resposta de conformidade, na ordem em que aparecem no botão. */
export const CONFORMITY_CHOICES = [
  { value: "conforme", label: "OK", tone: "ok" as const },
  { value: "nao_conforme", label: "Avaria", tone: "bad" as const },
  { value: "nao_se_aplica", label: "N/A", tone: "neutral" as const },
];

export const YES_NO_CHOICES = [
  { value: "sim", label: "Sim", tone: "ok" as const },
  { value: "nao", label: "Não", tone: "bad" as const },
];

export const MOVEMENT_LABEL: Record<"departure" | "arrival", string> = { departure: "Saída", arrival: "Retorno" };
